import { Carousel, CarouselProps } from 'antd'
import { TrashButton } from 'components/CantileverButton'
import React, { useState } from 'react'

interface ObservationCarouselProps {
  images: readonly string[]
  onRemove?: (index: number) => void
  defaultImageComponent?: React.ReactNode
  carouselProps?: CarouselProps
  imageStyle?: React.CSSProperties
  className?: string
  style?: React.CSSProperties
}

const defaultImageStyle: React.CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
}

const defaultCarouselProps: CarouselProps = {
  dots: true,
  arrows: false,
  autoplay: false,
}

export const ObservationCarousel: React.FC<ObservationCarouselProps> = ({
  images,
  onRemove,
  defaultImageComponent,
  carouselProps: customCarouselProps,
  imageStyle: customImageStyle,
  className,
  style,
}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  if (!images || images.length === 0) {
    return defaultImageComponent ? (
      <div className={className} style={style}>
        {defaultImageComponent}
      </div>
    ) : null
  }

  const combinedCarouselProps = {
    ...defaultCarouselProps,
    ...customCarouselProps,
    arrows:
      customCarouselProps?.arrows === false
        ? false
        : images.length > 1 || customCarouselProps?.arrows,
    dots:
      customCarouselProps?.dots === false
        ? false
        : images.length > 1 || customCarouselProps?.dots,
    afterChange: (current: number) => setCurrentSlideIndex(current),
  }

  const combinedImageStyle = { ...defaultImageStyle, ...customImageStyle }
  const slideContainerStyle: React.CSSProperties = {}

  const containerStyle: React.CSSProperties = {
    ...style,
    position: 'relative',
  }

  return (
    <div className={className} style={containerStyle}>
      <Carousel {...combinedCarouselProps}>
        {images.map((imageSrc, index) => (
          <div key={index} style={slideContainerStyle}>
            <img
              src={imageSrc}
              alt={`Observation image ${index + 1}`}
              style={combinedImageStyle}
            />
          </div>
        ))}
      </Carousel>

      {onRemove && images.length > 0 && (
        <TrashButton
          onClick={(e) => {
            e.stopPropagation()
            onRemove(currentSlideIndex)
          }}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            zIndex: 10,
          }}
          title={`Remove image ${currentSlideIndex + 1}`}
          ghost
        />
      )}
    </div>
  )
}
